module.exports = "https://s91588.cdn.ngenix.net/home/_next/static/images/credit@2x-e625fb0b8d0d6335c6d50328ec60f19e.png";